import { render, staticRenderFns } from "./subButton.vue?vue&type=template&id=4acb7989&scoped=true&"
import script from "./subButton.vue?vue&type=script&lang=js&"
export * from "./subButton.vue?vue&type=script&lang=js&"
import style0 from "./subButton.vue?vue&type=style&index=0&id=4acb7989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acb7989",
  null
  
)

export default component.exports